import React, { createContext } from 'react';

export const StoreContext = createContext({ store: {} });

interface ProviderProps {
    store?: object;
    children: any;
}

export default class Provider extends React.Component<ProviderProps> {
    public static contextType = StoreContext;

    private store: object;
    public constructor(props, context) {
        super(props, context);

        this.store = props.store;
    }

    public render() {
        return <StoreContext.Provider value={{ store: this.store }} >
            {this.props.children}
        </StoreContext.Provider>;
    }

    public getChildContext() {
        return {
            store: this.store,
        };
    }
}
